import i18n from '@/utils/i18n';
import React from 'react';
import { AppPageLayout } from '@experiences/templates/app-page-layout';
import { Breadcrumb, View } from '@usepepper/sprout-kit-ui';
import { FINANCE_HUB_ROUTES } from '@/navigators/routes';
import { FinanceHubAutopayStackParams } from '@/navigators/types';
import { FinanceHubShellTemplate } from '@finance-hub/templates/finance-hub-shell-template';
import { StackScreenProps } from '@react-navigation/stack';

type Props = StackScreenProps<
  FinanceHubAutopayStackParams,
  typeof FINANCE_HUB_ROUTES.AutopayRunPreview
>;

export const AutopayRunPreviewScreen: React.FC<Props> = ({ navigation }) => (
  <FinanceHubShellTemplate>
    <AppPageLayout
      leadingActions={
        <Breadcrumb>
          <Breadcrumb.Item>{i18n.t('finance_hub.title')}</Breadcrumb.Item>
          <Breadcrumb.Item
            onPress={() => navigation.navigate(FINANCE_HUB_ROUTES.Autopay)}
          >
            {i18n.t('finance_hub.autopay.title')}
          </Breadcrumb.Item>
          <Breadcrumb.Item current>
            {i18n.t('finance_hub.autopay.run_preview.breadcrumb_title')}
          </Breadcrumb.Item>
        </Breadcrumb>
      }
      scroll={false}
    >
      <View flex={1} paddingTop="$24" width="100%" />
    </AppPageLayout>
  </FinanceHubShellTemplate>
);
